import React, { useContext, useEffect, useReducer } from 'react';
import { Grid, Button, Accordion, AccordionDetails } from '@material-ui/core';
import { useStyles } from './styles';
import { Autocomplete, IOptions } from '../../../../components/migrated/autocomplete';
import { DatePicker } from '../../../../components/migrated/datepicker';
import { IFilters } from './interfaces';
import { Can } from '../../../../components/util/Can';
import { AuthContext } from '../../../../contexts/auth';
import { useSnackbar, useEnvironment } from '../../../../hooks';
import { initialFiltersState, reducerFilters } from './reducer';
import { useSuppliersGql } from '../../graphql/suppliers';
import Cookies from 'universal-cookie';
import moment from 'moment';

export type { IApplyFilters } from './interfaces';

export const Filters = (props: IFilters) => {
  const { user } = useContext(AuthContext);
  const { onApplyFilters } = props;
  const { runSuppliersGql, dataSuppliers, errorSuppliers, loadingSuppliers } = useSuppliersGql();
  const { DEBUG } = useEnvironment();
  const { Snackbar, toggleSnackbar } = useSnackbar();
  const classes = useStyles();
  const [state, dispatch] = useReducer(reducerFilters, initialFiltersState);
  const { endDate, invoiceType, startDate, supplier } = state;
  const invoiceTypes = [
    { key: 'D', value: 'Devolução' },
    { key: 'P', value: 'Pedidos' },
    { key: 'U', value: 'Descargas' }
  ];

  const handleSuppliers = (options: IOptions) => {
    options?.key && dispatch({ type: 'SUPPLIER', supplier: options.key });
  };

  const handleInvoiceTypes = (options: IOptions) => {
    options?.key && dispatch({ type: 'INVOICE_TYPE', invoiceType: options.key });
  };

  const handleStartDate = (date: Date | null) => {
    dispatch({ type: 'START_DATE', startDate: date });
  };

  const handleEndDate = (date: Date | null) => {
    date && dispatch({ type: 'END_DATE', endDate: date });
  };

  const handleDiffYears = (dateStart: Date, dateEnd: Date) => {
    const start = moment(dateStart, 'DD/MM/YYYY');
    const end = moment(dateEnd, 'DD/MM/YYYY');
    return end.diff(start, 'years');
  };

  const handleOnClick = async () => {
    if (!supplier) {
      toggleSnackbar({ message: 'Fornecedor deve ser selecionado!', type: 'warning' });
      return;
    }
    if (invoiceType === null) {
      toggleSnackbar({ message: 'Tipo de nota deve ser preenchido!', type: 'warning' });
      return;
    }
    if (startDate === null) {
      toggleSnackbar({ message: 'Data de início deve ser preenchida!', type: 'warning' });
      return;
    }
    if (endDate === null) {
      toggleSnackbar({ message: 'Data de fim deve ser preenchida!', type: 'warning' });
      return;
    }
    if (handleDiffYears(startDate, endDate) > 5) {
      toggleSnackbar({ message: 'Intervalo de datas muito longo', type: 'warning' });
      return;
    }
    onApplyFilters({ endDate, startDate, supplier, invoiceType });
  };

  useEffect(() => {
    runSuppliersGql();
    if (!user.permissions['filtro-fornecedor']) {
      const cookies = new Cookies();
      const userCode = cookies.get('User-Code');
      dispatch({ type: 'SUPPLIER', supplier: userCode });
    }
  }, []);

  useEffect(() => {
    if (errorSuppliers) {
      if (DEBUG === 'TRUE') {
        console.log(`Erro ao carregar dados! Error:(message: ${errorSuppliers} )`);
      } else {
        toggleSnackbar({
          message: 'Ocorreu um problema ao carregar os fornecedores. Por favor, informe ao suporte.',
          type: 'error'
        });
      }
    }
  }, [errorSuppliers]);

  return (
    <>
      <Snackbar />
      <div className={classes.root}>
        <Accordion>
          <AccordionDetails>
            <Grid container spacing={2}>
              <Can permissions={['filtro-fornecedor']}>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                  <Autocomplete
                    showObjectKey
                    objects={dataSuppliers!}
                    objectKey="personId"
                    objectValue="supplierName"
                    onChange={handleSuppliers}
                    label="Selecione o fornecedor"
                    defaultValue=""
                    loading={loadingSuppliers}
                  />
                </Grid>
              </Can>
              <Grid item xs={12} md={3}>
                <Autocomplete
                  objects={invoiceTypes}
                  objectValue="value"
                  defaultValue=""
                  objectKey="key"
                  onChange={handleInvoiceTypes}
                  label="Tipo de nota"
                  loading={false}
                />
              </Grid>
              <Grid item xs={12} sm={5} md={2} lg={2}>
                <DatePicker
                  label="Data início"
                  onChange={(date) => handleStartDate(date)}
                  selected={startDate}
                  value={startDate}
                />
              </Grid>
              <Grid item xs={12} sm={5} md={2} lg={2}>
                <DatePicker
                  label="Data fim"
                  onChange={(date) => handleEndDate(date)}
                  selected={endDate}
                  value={endDate}
                  minDate={startDate}
                />
              </Grid>
              <Grid item xs={12} sm={1} md={1} lg={1}>
                <Button variant="contained" color="primary" onClick={handleOnClick} className={classes.aplicar}>
                  Aplicar
                </Button>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  );
};
